import { render, staticRenderFns } from "./ResendConfirmationEmailAlert.vue?vue&type=template&id=796d51d3&"
import script from "./ResendConfirmationEmailAlert.vue?vue&type=script&lang=ts&"
export * from "./ResendConfirmationEmailAlert.vue?vue&type=script&lang=ts&"
import style0 from "./ResendConfirmationEmailAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports